module.exports = __webpack_public_path__ + "entry-150bfe9b/koster-photo-18f094782e5a014fe4b4138301a2a0bc.webp";